import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicyPage = ({ onBack }) => {
  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      {/* Back Button */}
      <motion.div 
        style={{ 
          padding: '20px',
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1000
        }}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <button 
          onClick={onBack}
          style={{
            background: '#7c3aed',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#6d28d9';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#7c3aed';
            e.target.style.transform = 'translateY(0px)';
          }}
        >
          ← Back to Home
        </button>
      </motion.div>

      <motion.div 
        className="privacy-policy-page"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          padding: '120px 20px 50px 20px',
          maxWidth: '1200px',
          margin: '0 auto',
          lineHeight: '1.6',
          color: '#333',
          backgroundColor: '#ffffff'
        }}
      >
        <motion.h1 
          style={{
            fontSize: '3rem',
            marginBottom: '20px',
            color: '#7c3aed',
            textAlign: 'center'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          📜 Privacy Policy
        </motion.h1>
        
        <motion.p 
          style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '40px',
            color: '#7c3aed'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Effective Date: 20/12/2024
        </motion.p>
        
        <motion.div 
          style={{
            fontSize: '1.1rem',
            marginBottom: '30px'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <p style={{ marginBottom: '30px' }}>
            LeadVala ("we," "our," "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and safeguard your data in compliance with global privacy laws (GDPR, CCPA, IT Act India) and advertising platform requirements (Google, Meta/Facebook, Instagram, LinkedIn, Twitter/X, etc.).
          </p>
        </motion.div>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            1. Information We Collect
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li><strong>Personal Data:</strong> Name, phone number, email, city, business category, and service preferences.</li>
            <li><strong>Lead Data:</strong> Information submitted through our OTP forms, WhatsApp flows, or call verification.</li>
            <li><strong>Technical Data:</strong> IP address, device type, browser, OS, and geolocation.</li>
            <li><strong>Cookies & Tracking Data:</strong> Collected via Google Analytics, Meta Pixel, LinkedIn Insight Tag, and other ad technologies.</li>
            <li><strong>Communication Data:</strong> WhatsApp messages, email responses, and call recordings (for Premium Verified Leads).</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            2. How We Use Your Information
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Deliver verified business leads to subscribed clients.</li>
            <li>Improve ad targeting and campaign optimization.</li>
            <li>Enhance customer experience and service delivery.</li>
            <li>Send marketing updates and newsletters (with consent).</li>
            <li>Comply with legal obligations.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            3. Sharing of Data
          </h2>
          <p style={{ marginBottom: '15px' }}>
            We <strong>do not sell or rent data</strong>. We may share it with:
          </p>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Subscribed clients (to deliver leads).</li>
            <li>Service providers (IT, analytics, telecom).</li>
            <li>Regulatory authorities, when legally required.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            4. Data Security
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Encryption for storage and transmission.</li>
            <li>Access restricted to authorized personnel only.</li>
            <li>Regular audits for compliance with platform rules.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            5. User Rights
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Request access, correction, or deletion of data.</li>
            <li>Opt out of communications via "STOP" on WhatsApp/email.</li>
            <li>Manage cookies via browser settings.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            6. Third-Party Platforms
          </h2>
          <p style={{ lineHeight: '2' }}>
            We advertise via <strong>Google, Facebook/Instagram, LinkedIn, Twitter/X, and other ad networks</strong>, which may collect user data. Please review their policies for details.
          </p>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.1 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            7. Children's Privacy
          </h2>
          <p style={{ lineHeight: '2' }}>
            We do not knowingly collect data from individuals under 18 years of age.
          </p>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            8. Policy Updates
          </h2>
          <p style={{ lineHeight: '2' }}>
            We may update this Privacy Policy at any time. Changes are effective immediately upon posting.
          </p>
        </motion.section>

        <motion.section 
          style={{
            marginTop: '50px',
            padding: '30px',
            backgroundColor: '#f8fafc',
            borderRadius: '10px',
            border: '2px solid #7c3aed'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.3 }}
        >
          <h3 style={{ fontSize: '1.5rem', marginBottom: '15px', color: '#7c3aed' }}>📍 Contact:</h3>
          <p style={{ lineHeight: '2', fontSize: '1.1rem' }}>
            LeadVala, 726 Sun Gravitas, Shyamal, Ahmedabad, Gujarat, India<br/>
            📞 +91-97999 18691 | 🌐 www.leadvala.com
          </p>
        </motion.section>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicyPage;